export const TABLIST = {
  USER_PROFILE: "USER_PROFILE",
  CGM_DATA: "CGM_DATA",
  ANOMALIES: "ANOMALIES",
};

export const TABLIST_TEXT_MAPPING = {
  [TABLIST.USER_PROFILE]: "User profile",
  [TABLIST.CGM_DATA]: "Device data",
  [TABLIST.ANOMALIES]: "Anomalies",
};

export const TABLIST_ARRAY = [
  TABLIST.USER_PROFILE,
  TABLIST.CGM_DATA,
  TABLIST.ANOMALIES,
];

export const CHART_VIEW_TYPES = {
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

export const CHART_VIEW_TYPES_TEXT_MAPPING: any = {
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
};

export const USER_METRICS_UNIT_MAPPING = {
  HEART_RATE: "bpm",
  CALORIES: "kcal",
  VO2MAX: "ml/(kg·min)",
  TIME: " h/min",
};

export const SENSOR_STATUS_MAPPING = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  NEW: "NEW",
};

export const SENSOR_STATUS_CLASS_MAPPING = {
  [SENSOR_STATUS_MAPPING.ACTIVE]: "text-success",
  [SENSOR_STATUS_MAPPING.EXPIRED]: "text-danger",
  [SENSOR_STATUS_MAPPING.NEW]: "text-secondary",
};
